import { render, staticRenderFns } from "./recommend_item.vue?vue&type=template&id=57506a12&scoped=true&"
import script from "./recommend_item.vue?vue&type=script&lang=ts&"
export * from "./recommend_item.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item.vue?vue&type=style&index=0&id=57506a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57506a12",
  null
  
)

export default component.exports